<template>
  <div>
    <view-shop-audit-info ref="viewShopAuditInfo" />
  </div>
</template>

<script>
import ViewShopAuditInfo from '@/components/goods/viewShopAuditInfo/viewShopAuditInfo.vue'
import { queryShopAudit } from '@/api/goods/shopAuditApi'

export default {
  name: 'ViewShopAudit',
  components: {
    ViewShopAuditInfo
  },
  created() {
    const auditId = this.$route.query.auditId
    const shopId = this.$route.query.shopId
    
    if (!auditId || !shopId) {
      this.$message.error('参数错误')
      this.$router.go(-1)
      return
    }
    
    // 查询审核信息
    queryShopAudit({ auditId, shopId, page: 1, row: 1 }).then(res => {
      if (res.data && res.data.length > 0) {
        this.$nextTick(() => {
          this.$refs.viewShopAuditInfo.open(res.data[0])
        })
      } else {
        this.$message.error('未找到审核信息')
        this.$router.go(-1)
      }
    }).catch(error => {
      console.error('查询审核信息失败:', error)
      this.$message.error('查询审核信息失败')
      this.$router.go(-1)
    })
  }
}
</script>

<style scoped>
</style>

